module.exports = __webpack_public_path__ + "static/media/anim_astronaut.ed79e38b.png";